var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app"
  }, [_c('header', {
    staticClass: "app-header"
  }, [(_vm.settings) ? _c('Navbar', {
    attrs: {
      "facebook": _vm.settings.facebook
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    key: _vm.$route.params.id
  })], 1), _vm._v(" "), (_vm.settings) ? _c('AppFooter', {
    attrs: {
      "facebook": _vm.settings.facebook
    }
  }, [_c('p', {
    staticClass: "app-footer__copy",
    slot: "left"
  }, [_vm._v("© 2017 - Moeto-Zdrave.com - Всички права запазени.")]), _vm._v(" "), _c('p', {
    staticClass: "app-footer__dev",
    slot: "right"
  }, [_vm._v("Изработка на сайт от "), _c('a', {
    staticClass: "grindwebstudio",
    attrs: {
      "target": "_blank",
      "href": "https://grindwebstudio.com/"
    }
  }, [_vm._v("Grind Web Studio")])])]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03ad3276","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = FwHy
// module chunks = 1